module.exports = __webpack_public_path__ + "img/Postmodernisme_Tanker_i_tiden1.801b5970.jpg";